
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actuary/guide",
      function () {
        return require("private-next-pages/actuary/guide/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/actuary/guide"])
      });
    }
  